/* global openLayersUrl */
/* global googleMapsUrl */

var Map = require('js/lib/map/map');

mapDirective.$inject = ['$rootScope', '$location', '$routeParams', '$compile', 'loadScript', 'modal', 'storage', 'clock', '$timeout'];

function mapDirective($rootScope, $location, $routeParams, $compile, loadScript, modal, storage, clock, $timeout) {

  return {
    template: require('html/templates/map'),
    restrict: 'E',
    replace: true,
    link: function(scope) {
      loadScript.loadAll([openLayersUrl, googleMapsUrl]).then(function() {
        //The $timeout is needed so you get the correct class on the map from ng-class.
        //$timeout also runs $apply which will run angulars watchers, this is necessary in order to run translation.
        $timeout(function() {
          new Map(scope, $rootScope, $location, $compile, modal, storage, clock, +$routeParams.routeId, +$routeParams.routeSequence);
        });
      });
    }
  };
};

module.exports = mapDirective;



/*****************
 ** WEBPACK FOOTER
 ** ./src/js/directives/map.js
 ** module id = 145
 ** module chunks = 1
 **/